export enum TimePriority {
  Important = 'IMPORTANT',
  NotImportant = 'NOT_IMPORTANT',
}
